export const LOYALTY_PUSH_WITH_ICONS = 'Loyalty push - With icons';
export const LOYALTY_PUSH_BANNER_TEXT = 'Loyalty push - Banner/Text';
